export const UPLOAD_GROUP_FILES = `
mutation uploadGroupFiles($tenant_id: Int!, $group_id: Int!, $files: [Upload!]!) {
  uploadGroupFiles(tenant_id: $tenant_id, group_id: $group_id, files: $files) {
    __typename
    ... on GroupFile {
      id
      group_id
      filename
      mimetype
      encoding
      url
      its
    }
    ... on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const DELETE_GROUP_FILE = `
mutation deleteGroupFile($tenant_id: Int!, $id: Int!) {
  deleteGroupFile(tenant_id: $tenant_id, id: $id) {
    __typename
    ... on GroupFile {
      id
    }
    ... on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;
